(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('offlinePriceRequestService', offlinePriceRequestService);

    offlinePriceRequestService.$inject = ['$http', 'guard'];
    function offlinePriceRequestService($http, guard) {
        var baseUrl = "/3dprint";

        var service = {
            requestPrice: requestPrice,
            requestPrices: requestPrices
        };

        return service;

        // --------------------------------------------------------------------------------------------------

        function requestPrice(productInfo) {
            guard.argumentIsObject(productInfo, "productInfo");

            return requestPrices([productInfo]);
        }

        function requestPrices(productInfos) {
            guard.argumentIsArray(productInfos, "productInfos");

            return $http.post(baseUrl + "/request-prices", productInfos)
                .then(function (response) {
                    return response.data;
                });
        }
    }
})();